import { toast } from "react-toastify";
import CircularProgress from '@mui/material/CircularProgress';

export const handleSuccess = (msg)=>{
    toast.success(msg, {
        position : 'top-right'
    })
}

export const handleError = (msg)=>{
    toast.error(msg,  {
        position : 'top-right'
    })
}
export const handleInfo= (msg)=>{
    toast.info(msg, {
        position : 'top-right'
    })
}

// Lazily injects the Razorpay checkout script only when payment is needed.
export const loadRazorpay = () =>
  new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve();
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = resolve;
    script.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
    document.body.appendChild(script);
  });

export const ComponentLoading = () => (
  <div className="flex justify-center items-center p-8">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
);


const CodeQueueSpinner = () => {
  return (
    <div>
        <div className="text-center"><CircularProgress disableShrink /></div>
    </div>
  )
}

export default CodeQueueSpinner